import { useAuthStore } from '@/modules/auth/presentation/store/auth.store';
import { ADMINISTRATOR, hasAnyRole, IMPERSONATOR } from '@/shared/guards/roles';

/**
 * Pode "atuar como" outro usuário **aqui no admin-dashboard**? Só ADMINISTRATOR
 * ou SYSTEM_ADMINISTRATOR (curinga) nos papéis **reais** do login: o
 * IMPERSONATOR só mascara no aristo-medq, e o monolith recusa abrir a sessão
 * dele em outro scope. É só UX — a autoridade real é o backend.
 */
export function useCanImpersonate(): boolean {
  const auth = useAuthStore((s) => s.auth);
  return hasAnyRole(auth?.roles ?? [], [ADMINISTRATOR]);
}

/**
 * Pode abrir a máscara no app MedQ? Aqui o IMPERSONATOR também entra: é o único
 * destino dele (decisão 12 do épico act-as). Mesmo recorte de papéis reais.
 */
export function useCanImpersonateOnMedq(): boolean {
  const auth = useAuthStore((s) => s.auth);
  return hasAnyRole(auth?.roles ?? [], [ADMINISTRATOR, IMPERSONATOR]);
}
